import { useEffect, useRef, useState } from "react";

export function useAutoHideUI(timeout = 5000) {
  const [uiVisible, setUiVisible] = useState(true);
  const hideTimeout = useRef<number | null>(null);

  useEffect(() => {
    const scheduleHide = () => {
      if (hideTimeout.current) clearTimeout(hideTimeout.current);
      hideTimeout.current = window.setTimeout(() => {
        setUiVisible(false);
      }, timeout);
    };

    const reveal = () => {
      setUiVisible(true);
      scheduleHide();
    };

    const handleVisibilityChange = () => {
      if (!document.hidden) {
        reveal();
      }
    };

    window.addEventListener("mousemove", reveal);
    window.addEventListener("pointerdown", reveal);
    window.addEventListener("pointermove", reveal);
    window.addEventListener("touchstart", reveal, { passive: true });
    window.addEventListener("touchmove", reveal, { passive: true });
    window.addEventListener("keydown", reveal);
    document.addEventListener("visibilitychange", handleVisibilityChange);
    hideTimeout.current = window.setTimeout(() => setUiVisible(false), timeout);

    return () => {
      window.removeEventListener("mousemove", reveal);
      window.removeEventListener("pointerdown", reveal);
      window.removeEventListener("pointermove", reveal);
      window.removeEventListener("touchstart", reveal);
      window.removeEventListener("touchmove", reveal);
      window.removeEventListener("keydown", reveal);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      if (hideTimeout.current) clearTimeout(hideTimeout.current);
    };
  }, [timeout]);

  return uiVisible;
}
